import { instantsInterceptor, } from '@/api/index';
import axios from "axios";
import { setInterceptors } from "@/api/common/interceptor";

function getAccessByRegionChartData(startDate, endDate) {
    return instantsInterceptor.get('/mgmt/statistics/accessbyregion/result?' + 'startDate=' + startDate + '&endDate=' + endDate);
}

function getAccessByCountryChartData(startDate, endDate) {
    return instantsInterceptor.get('/mgmt/statistics/accessbycountry/result?' + 'startDate=' + startDate + '&endDate=' + endDate);
}

function getAccessByLanguagesChartData(startDate, endDate) {
    return instantsInterceptor.get('/mgmt/statistics/accessbylanguages/result?' + 'startDate=' + startDate + '&endDate=' + endDate);
}

function getAccessByTimezoneChartData(startDate, endDate) {
    return instantsInterceptor.get('/mgmt/statistics/accessbytimezone/result?' + 'startDate=' + startDate + '&endDate=' + endDate);
}

function getAccessByPreferenceDeviceChartData(startDate, endDate) {
    return instantsInterceptor.get('/mgmt/statistics/accessbypreferencedevice/result?' + 'startDate=' + startDate + '&endDate=' + endDate);
}

function getAccessByModelChartData(startDate, endDate, tier) {
    return instantsInterceptor.get('/mgmt/statistics/accessbymodel/result?' + 'startDate=' + startDate + '&endDate=' + endDate + "&tier=" + tier);
}

function getAccessByRecentModelChartData() {
    return instantsInterceptor.get('/mgmt/statistics/recentmodel/result');
}

function getEngineTier() {
    return instantsInterceptor.get('/mgmt/statistics/accessbymodel/tier');
}

function getAccessByTopicChartData(startDate, endDate) {
    return instantsInterceptor.get('/mgmt/statistics/accessbytopic/result?' + 'startDate=' + startDate + '&endDate=' + endDate);
}

function getAccessByFunctionChartData(startDate, endDate) {
    return instantsInterceptor.get('/mgmt/statistics/accessbyfunction/result?' + 'startDate=' + startDate + '&endDate=' + endDate);
}

function accessByPreferenceDeviceExcel(startDate, endDate) {
    return blobInstance().get('/mgmt/statistics/accessbypreferencedevice/excel?' + 'startDate=' + startDate + '&endDate=' + endDate);
}


function blobInstance() {
    let axiosInstance = axios.create({
        baseURL: process.env.VUE_APP_API_URL,
        headers: {
            'Access-Control-Allow-Origin': '*',
        },
        responseType: 'blob',
    });

    return setInterceptors(axiosInstance);
}

function accessByRegionExcel(startDate, endDate) {
    return blobInstance().get('/mgmt/statistics/accessbyregion/excel?' + 'startDate=' + startDate + '&endDate=' + endDate);
}

function accessByCountryExcel(startDate, endDate) {
    return blobInstance().get('/mgmt/statistics/accessbycountry/excel?' + 'startDate=' + startDate + '&endDate=' + endDate);
}

function accessByLanguagesExcel(startDate, endDate) {
    return blobInstance().get('/mgmt/statistics/accessbylanguages/excel?' + 'startDate=' + startDate + '&endDate=' + endDate);
}

function accessByTimezoneExcel(startDate, endDate) {
    return blobInstance().get('/mgmt/statistics/accessbytimezone/excel?' + 'startDate=' + startDate + '&endDate=' + endDate);
}

function accessByTopicExcel(startDate, endDate) {
    return blobInstance().get('/mgmt/statistics/accessbytopic/excel?' + 'startDate=' + startDate + '&endDate=' + endDate);
}

function accessByFunctionExcel(startDate, endDate) {
    return blobInstance().get('/mgmt/statistics/accessbyfunction/excel?' + 'startDate=' + startDate + '&endDate=' + endDate);
}

function accessByModelExcel(startDate, endDate, tier) {
    return blobInstance().get('/mgmt/statistics/accessbymodel/excel?' + 'startDate=' + startDate + '&endDate=' + endDate + '&tier=' + tier);
}

function accessByRecentModelExcel() {
    return blobInstance().get('/mgmt/statistics/recentmodel/excel');
}

export {
    getAccessByRegionChartData,
    getAccessByLanguagesChartData,
    getAccessByTimezoneChartData,
    getAccessByPreferenceDeviceChartData,
    getAccessByModelChartData,
    getAccessByCountryChartData,
    getAccessByRecentModelChartData,
    accessByPreferenceDeviceExcel,
    accessByRegionExcel,
    accessByCountryExcel,
    accessByLanguagesExcel,
    accessByTimezoneExcel,
    accessByTopicExcel,
    accessByFunctionExcel,
    accessByModelExcel,
    accessByRecentModelExcel,
    getEngineTier,
    getAccessByTopicChartData,
    getAccessByFunctionChartData
};
